import React from 'react'
import { TableRowField } from '../../../../components'
import moment from 'moment';

export function customerDetailXS() {
    return ([
        {
            dataField: 'xs',
            text: 'Venta',
            formatter: (cell, row) => {
                const products = (row.details.products.length > 0) ? row.details.products.join(", ") : "Sin productos";
                const services = (row.details.services.length > 0) ? row.details.services.join(", ") : "Sin servicios";
                const offers = (row.details.offers.length > 0) ? row.details.offers.join(", ") : "Sin ofertas";
                return (
                    <div>
                        <TableRowField label='Fecha de Compra:' value={moment(row.created_at).format('DD-MM-YYYY HH:mm')} />
                        <TableRowField label='Precio Total:' value={row.total_price} />
                        <TableRowField label='Total Cancelado:' value={row.cash_payed + row.credit_payed} />
                        {(row.change > 0) ? <TableRowField label='Vuelto:' value={row.change} /> : null}
                        {(row.debt > 0) ? <TableRowField label='Deuda:' value={row.debt} /> : null}
                        <TableRowField label='Método de pago:' value={row.Sell_payment_type.name} />
                        <TableRowField label='Comprobante de pago:' value={row.receipt_type} />
                        <TableRowField label='Concepto:' value={''} />
                        <TableRowField label='Productos:' value={products} />
                        <TableRowField label='Servicios:' value={services} />
                        <TableRowField label='Ofertas:' value={offers} />
                    </div>
                )
            }
        }
    ])
}

export function customerDetailSM() {
    return ([
        {
            dataField: 'sm',
            text: 'Venta',
            formatter: (cell, row) => {
                return (
                    <div>
                        <TableRowField label='Fecha de Compra:' value={moment(row.created_at).format('DD-MM-YYYY HH:mm')} />
                        <TableRowField label='Precio Total:' value={row.total_price} />
                        <TableRowField label='Total Cancelado:' value={row.cash_payed + row.credit_payed} />
                        {(row.change > 0) ? <TableRowField label='Vuelto:' value={row.change} /> : null}
                        {(row.debt > 0) ? <TableRowField label='Deuda:' value={row.debt} /> : null}
                        <TableRowField label='Método de pago:' value={row.Sell_payment_type.name} />
                        <TableRowField label='Comprobante de pago:' value={row.receipt_type} />
                    </div>
                )
            }
        },
        {
            dataField: 'details',
            text: 'Concepto',
            formatter: (cell, row) => {
                const products = (row.details.products.length > 0) ? row.details.products.join(", ") : "Sin productos";
                const services = (row.details.services.length > 0) ? row.details.services.join(", ") : "Sin servicios";
                const offers = (row.details.offers.length > 0) ? row.details.offers.join(", ") : "Sin ofertas";
                return (
                    <div>
                        <TableRowField label='Productos:' value={products} />
                        <TableRowField label='Servicios:' value={services} />
                        <TableRowField label='Ofertas:' value={offers} />
                    </div>
                )
            }
        },
    ])
}

export function customerDetailMD() {
    return ([
        {
            dataField: 'created_at',
            text: 'Fecha de Compra',
            formatter: (cell, row) => {
                return (
                    <span>{moment(row.created_at).format('DD-MM-YYYY HH:mm')}</span>
                )
            }
        },
        {
            dataField: 'total_price',
            text: 'Precio Total'
        },
        {
            dataField: 'total_price_client',
            text: 'Total Cancelado',
            formatter: (cell, row) => {
                return (
                    <div>
                        <span>{row.cash_payed + row.credit_payed}</span>
                        {(row.change > 0) ? <TableRowField label='Vuelto:' value={row.change} /> : null}
                        {(row.debt > 0) ? <TableRowField label='Deuda:' value={row.debt} /> : null}
                    </div>
                )
            }
        },
        {
            dataField: 'Sell_payment_type',
            text: 'Detalles de pago',
            formatter: (cell, row) => {
                return (
                    <div>
                        <TableRowField label='Método de pago:' value={row.Sell_payment_type.name} />
                        <TableRowField label='Comprobante de pago:' value={row.receipt_type} />
                    </div>
                )
            }
        },
        {
            dataField: 'details',
            text: 'Concepto',
            formatter: (cell, row) => {
                const products = (row.details.products.length > 0) ? row.details.products.join(", ") : "Sin productos";
                const services = (row.details.services.length > 0) ? row.details.services.join(", ") : "Sin servicios";
                const offers = (row.details.offers.length > 0) ? row.details.offers.join(", ") : "Sin ofertas";
                return (
                    <div>
                        <TableRowField label='Productos:' value={products} />
                        <TableRowField label='Servicios:' value={services} />
                        <TableRowField label='Ofertas:' value={offers} />
                    </div>
                )
            }
        },
    ])
}

export function customerDetail() {
    return ([
        {
            dataField: 'created_at',
            text: 'Fecha de Compra',
            formatter: (cell, row) => {
                return (
                    <span>{moment(row.created_at).format('DD-MM-YYYY HH:mm')}</span>
                )
            }
        },
        {
            dataField: 'total_price',
            text: 'Precio Total'
        },
        {
            dataField: 'total_price_client',
            text: 'Total Cancelado',
            formatter: (cell, row) => {
                return (
                    <div>
                        <span>{row.cash_payed + row.credit_payed}</span>
                        {(row.change > 0) ? <TableRowField label='Vuelto:' value={row.change} /> : null}
                        {(row.debt > 0) ? <TableRowField label='Deuda:' value={row.debt} /> : null}
                    </div>
                )
            }
        },
        {
            dataField: 'Sell_payment_type.name',
            text: 'Método de pago'
        },
        {
            dataField: 'receipt_type',
            text: 'Comprobante de pago'
        },
        {
            dataField: 'details.products',
            text: 'Productos',
            formatter: (cell, row) => {
                const products = (row.details.products.length > 0) ? row.details.products.join(", ") : "Sin productos";
                return (
                    <span>{products}</span>
                )
            }
        },
        {
            dataField: 'details.services',
            text: 'Servicios',
            formatter: (cell, row) => {
                const services = (row.details.services.length > 0) ? row.details.services.join(", ") : "Sin servicios";
                return (
                    <span>{services}</span>
                )
            }
        },
        {
            dataField: 'details.offers',
            text: 'Ofertas',
            formatter: (cell, row) => {
                const offers = (row.details.offers.length > 0) ? row.details.offers.join(", ") : "Sin ofertas";
                return (
                    <span>{offers}</span>
                )
            }
        },
    ])
}


// WEBPACK FOOTER //
// ./src/scenes/Administration/Customer/CustomerDetail/_columns.js